function ContentSkeleton() {
  return (
    <div role="status" aria-label="Loading page content" className="animate-pulse space-y-6">
      {/* Title bar placeholder */}
      <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-1/3" />
      {/* Content block placeholders */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="h-24 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="h-24 bg-gray-200 dark:bg-gray-700 rounded" />
        <div className="h-24 bg-gray-200 dark:bg-gray-700 rounded" />
      </div>
      <div className="h-64 bg-gray-200 dark:bg-gray-700 rounded" />
    </div>
  )
}

export default ContentSkeleton
